import { inject, ChangeDetectionStrategy, Component, Input, OnInit, Renderer2, ElementRef } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { NPageSearch } from '../../../search/page-search.interfaces';
import { NPageHeader } from '../../page-header.component';

@Component({
    selector: 'page-header-meganav-content',
    templateUrl: 'page-header-meganav-content.html',
    styleUrls: ['page-header-meganav-content.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderMeganavContentComponent extends UiComponent implements OnInit {
    /**
     * Meganav items
     */
    @Input()
    content?: NPageHeader.IBlockDataContent;

    private loaded = false; // if component is loaded with content and class timepout is set

    /**
     * Services
     */
    readonly toggleService = inject(ToggleService);
    readonly renderer2 = inject(Renderer2);
    readonly elementRef = inject(ElementRef);

    /**
     * Group id for toggle service
     */
    readonly toggleGroupId = NPageHeader.MEGANAV_GROUP_ID;

    /**
     * Group id for toggle service
     */
    readonly searchMeganavKey = NPageSearch.SEARCH_MEGANAV_KEY;

    onMouseIn(index: number): void {
        if (!this.client.isCms) {
            this.toggleService.open([this.toggleGroupId, index]);
        }
    }

    onMouseOut(index: number): void {
        if (!this.client.isCms) {
            this.toggleService.close([this.toggleGroupId, index], { delay: 300 });
        }
    }

    override ngOnInit(): void {
        this.subscriptions.add(
            this.toggleService.getState(this.toggleGroupId).subscribe(state => {
                if (state && !this.loaded) {
                    this.renderer2.addClass(this.elementRef.nativeElement, '_loaded');
                }
            })
        );
        super.ngOnInit();
    }

    protected getItemWithId(item: NPageHeader.IMeganavItem): NPageHeader.IMeganavItem {
        item.id = 'meganav-content-item';
        return item;
    }
}
